import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

const velList = async () => {
  const { data } = await axiosInstance.get(
    `/api/abo/vel`
  );
  return data;
};

export const useVelList = () => {
  return useQuery({
    queryKey: ["vel"],
    queryFn: velList,
  });
};
